import React, { Component } from 'react';
import Switch from "react-switch";
import Select from 'react-select';

import { Popover, OverlayTrigger, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import { consultaMatInscrita, verEstudianesInsc } from '../../funciones/InscripcionFunction';

let chkStatus = true;

class InscripcionTable extends Component {
    state = {
        check: false,
        preloader: "fa fa-circle-o",
        tr: [],
        materias:this.props.materiasS,
        uc: 0,
        valorTipo: { value: '', label: '- SELECCIONA -' },
        tipos: [{ value: '', label: ' - Cargando Espere - '}],
        selectDisabled: false,
        bs: 0,
        semestre:"",
        chkLoad: true
    }

    constructor (props) {
        super (props);
        let { opciones } = this.props;
        setTimeout(() => {
            /* console.log(opciones) */
            consultaMatInscrita (this.props.Estudiante, this.props.opciones.seccionId, (resp) => {

                let observ = `${opciones.HoraOut} ${opciones.HoraIn}`;
                chkStatus = false;
                this.setState({
                    chkLoad: false,
                    check: resp[0],
                    uc: resp[1],
                    bs: resp[5],
                    valorTipo: resp[3],
                    tipos: resp[4]
                }, () => {
                    if (resp[0] === true && resp[2] === 1){
                        /* let Sec= {
                            id: opciones.seccionId,
                            tipo: this.state.valorTipo.value,
                            materia: seccion.materia,
                            seccion: seccion.seccion,
                            cupos: seccion.cupos,
                            tipoM: this.state.valorTipo
                        } */

                        this.props.add(opciones.materiaId, opciones.seccionId, this.state.uc, this.state.bs, observ)
                    } 
                    if (resp[0] === false && resp[2] === 1){

                        this.props.del(opciones.materiaId, opciones.seccionId, this.state.uc, this.state.bs, observ)
                    } 
                })
            })
        }, this.props.sec);
    }

    cambiaTipo = (valorTipo) => {
        this.setState({ valorTipo })
    }

    cambiacheck= (seccion) => (e) => {
        let observ = `${seccion.HoraOut} ${seccion.HoraIn}`;

        let Sec= {
            id: seccion.seccionId,
            tipo: this.state.valorTipo.value,
            materia: seccion.materia,
            seccion: seccion.seccion,
            cupos: seccion.cupos,
            tipoM: this.state.valorTipo
        }

        let estadoCheck = this.state.check
        if(estadoCheck === false) {
            let cantidad = 1;
            let data = this.props.materiasS
            let check = true;
            
            for (let i in data) {
                if(data[i] === seccion.materiaId) cantidad ++;
            }

            if (this.props.opciones.cupos <= 0){
                check = false
                    toast.error("No puedes seleccionar esta materia porque no posee cupos disponibles en esta sección",{autoClose: 4000});
                    this.setState({
                        check: check,
                })
            }else{
                if (cantidad > 1){
                    check = false
                    toast.error("No puedes seleccionar materias duplicadas aunque estén en distinta sección",{autoClose: 4000});
                    this.setState({
                        check: check,
                    })
                }else{
                    this.setState({
                        selectDisabled: true,
                        check: check,
                    }, () => {
                        this.props.add(seccion.materiaId, Sec, this.state.uc, this.state.bs, observ)
                    })
                }
            }
        }else{
            this.setState({
                selectDisabled: false,
                check: false,
            }, () => {
                this.props.del(seccion.materiaId, Sec, this.state.uc, this.state.bs) 
            }) 
        }

    }

    verEstudiantes = (id) => (e) => {
        verEstudianesInsc(id, (resp) => {
            this.setState({
                tr: resp
            })
        })
    }

    estudiantes = () => {
        let { tr } = this.state;
        if (tr.length === 0) return (
            <tr align="center" style={{fontSize:12}}>
                <td style={{fontSize:10}}> Ninguno </td>
            </tr>
        )
        return(
            tr.map(option => (
                <tr key={option.ci}>
                    <td style={{fontSize:10}}>{`${option.nombre1} ${option.nombre2} ${option.apellido1} ${option.apellido2}`}</td>
                </tr>
            ))
        )
    }

    materiaContent = (materia) => {
        /* if (materia.tipo_mat === "ELECTIVA") console.log(materia.materia) */
        return (materia.materia)
    }

    render() {
        let { opciones } = this.props;
        let { check, valorTipo, selectDisabled, tipos, chkLoad } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let infoSeccion = (
            <Popover bsSize="large" title="Información Adicional de la Sección" id="infoSeccion">
                <div style={{fontSize: 10}}>Profesor: <strong className="text-primary">{opciones.prof}</strong></div>
                <div style={{fontSize: 10}}>Aula: <strong className="text-primary">{opciones.aula}</strong></div>
                <div className="table-responsive custom-mt-10" style={{ overflowY :"auto", height:"45vh",}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td style={styles}><strong>Estudiantes Inscritos</strong></td>
                            </tr>
                            {this.estudiantes(opciones.seccionId)}
                        </tbody>
                    </Table>
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });
        
        return (
            <tr>
                <td style={styles}>
                    <strong>{this.materiaContent(opciones)}
                    <div className='text-primary'>{opciones.HoraOut} {opciones.HoraIn}</div></strong>
                </td>
                <td align="center" style={styles}>{opciones.seccion}</td>
                <td align="center" style={styles}>{opciones.cupos}</td>
                <td align="center" style={styles}>{this.state.uc}</td>
                <td align="center" style={styles} title= {`Seleccionado: ${valorTipo.label}`}>
                    <Select
                        isLoading = {chkLoad}
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={valorTipo}
                        onChange={this.cambiaTipo}
                        options={tipos}
                        isDisabled = {selectDisabled}
                    />
                </td>
                <td align="center" style={styles}>
                    <OverlayTrigger trigger="focus" placement="left" overlay={infoSeccion}>
                        <button onClick={this.verEstudiantes(opciones.seccionId)} style={{borderWidth: 1}} className="btn btn-relleno-primary btn-sm" title="Ver más información de la sección"><i className="fa fa-question-circle-o"></i></button>
                    </OverlayTrigger>
                </td>
                <td align="center" style={styles} title= "Seleccionar Materia">
                    <Switch disabled={chkStatus} height={12} width={24} onChange={this.cambiacheck(opciones)} checked={check} />
                </td>
            </tr>
        );
    }
}
 
export default InscripcionTable;



// WEBPACK FOOTER //
// ./src/views/Inscripcion/InscripcionTable.jsx